import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Button } from "@perxis-auto/ui-kit/lib/components/Button";
import { Row, Col } from "@perxis-auto/ui-kit/lib/components/Grid";
import styles from "./VehiclesCatalog.module.scss.js";
const VehiclesCatalog = memo(function VehiclesCatalog2({
  onShowMore,
  isMorePages,
  renderPages,
  t
}) {
  return /* @__PURE__ */ jsx("div", { className: styles.vehiclesCatalog, children: /* @__PURE__ */ jsxs(Row, { justify: "center", children: [
    /* @__PURE__ */ jsx(Col, { span: 24, className: styles.vehiclesCatalog__pagesCol, children: renderPages() }),
    isMorePages ? /* @__PURE__ */ jsx(Col, { span: 24, flex: "0 0 auto", className: styles.vehiclesCatalog__buttonCol, children: /* @__PURE__ */ jsx(Button, { type: "ghost", onClick: onShowMore, children: t("widgets.vehiclesCatalog.showMore") }) }) : null
  ] }) });
});
export {
  VehiclesCatalog
};
